import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceParams } from "@refinedev/core";
import { useOne } from "@/hooks";
import { Card, Row, Col, Input, Switch, Typography } from 'antd';
import { useTranslation } from "react-i18next";

const { TextArea } = Input;
const { Text } = Typography;
export const ProfileDetailPanel = () => {
  const { t } = useTranslation();
  const { state } = useResourceContext();
  const { action } = useResourceParams();
  const isList = action === "list";
  const isShow = action === "show";
  const selected = (isList || isShow) && state.selectedResources[0];
  const { data, isLoading } = useOne({
    resource: "profiles",
    id: action === "list" ? selected?.name : null,
    skip: isList && !selected,
  });
  let loading = isList ? false : isLoading;
  let instance = selected ? (isList ? data || selected : data) : null;

  return (
    <div>
      {loading && <div>Loading...</div>}
      {instance && 
    <Card style={{ width: "100%",  marginTop: 0 }}>
      <Row align="top">
        <Col flex="400px" style={{paddingRight: 30}}>
          <Row align="top" style={{ marginBottom: 8 }}>
            <Col span={6} ><Text strong>{t("settings.profiles.fields.name")}</Text></Col>
            <Col span={18}>{instance.name}</Col>
          </Row>

          <Row align="top" style={{ marginBottom: 8 }}>
            <Col span={6} ><Text strong>{t("settings.profiles.fields.desc")}</Text></Col>
            <Col span={18}>
              <TextArea value={instance.desc} readOnly rows={3} style={{width:"100%",height:"100%", resize:"none"}}/>          
            </Col>
          </Row>
        </Col>
        <Col flex="auto" >
          <Row style={{ marginBottom: 8 }} align="top">
            <Col flex="100px"><Text strong>{t("settings.profiles.fields.def")}</Text></Col>
            <Col flex="auto">
              <TextArea value={JSON.stringify(instance.profile||{}, null, 2)} readOnly rows={8} style={{width:"100%",height:"100%", resize:"none"}}/>          
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>}
    </div>
  );

};
